import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import { createSelectorRx } from "keautils";
import { observeResource, invalidateResource } from "kea-resource";
import { FiltroComponent } from "./filtro";
import { CargaDescargaCajaRutaDtoList } from "./list";

type Entity = models.ManifiestosCargaDescargaFiltro;

export interface Props {
    value?: Entity;
    onChange: (x: Entity) => void;
}
class ListFiltroCargasDescargasControlled extends React.PureComponent<Props> {
    onRefrescar = async () => {
        await invalidateResource(resources.CargaDescarga);
    }

    filtro = (props: Props) => props.value || {} as models.ManifiestosCargaDescargaFiltro;
    items = createSelectorRx(this.filtro, filtro => observeResource(resources.CargaDescarga.ConsultaManifiestosCargasDescargas, filtro ));
    
    render() {
        const filtro = this.filtro(this.props);
        const items = this.items(this.props);
        debugger;
        
        return (
            <div>
                <FiltroComponent value={filtro} onChange={this.props.onChange} />
                <CargaDescargaCajaRutaDtoList value={items} />
            </div>)
    }
}

export const ListFiltroCargasDescargas = kea.makeUncontrolledCookies<Partial<Props>>("value", "onChange")(ListFiltroCargasDescargasControlled);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/consultaMovimientosCarga/list/cargasdescargas/listfiltro.tsx